import { appendFiles, appendLocation, buildEncryptedDocumentUrl, fetchEncryptedImage } from "@/api/helpers";

const baseURL = `${process.env.VUE_APP_SERVER_URL}/Solicitacao`;

export async function DetalheProtocolo({ vinculo, protocolo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/DetalheProtocolo`,
      query: {
        vinculo,
        protocolo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("DetalheProtocolo", error.message);
      return error;
    });
}

export async function NovaSolicitacao({ vinculo, beneficiario, tipo, observacao, arquivos, autenticacao }) {
  const data = new FormData();
  data.append("beneficiario", beneficiario);
  data.append("tipo", tipo);
  data.append("observacao", observacao);
  data.append("autenticacao", autenticacao);
  appendFiles(data, arquivos);
  await appendLocation(data, true);
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/NovaSolicitacao`,
      query: {
        vinculo
      },
      contentType: "multipart/form-data",
      data
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("NovaSolicitacao", error.message);
      return error;
    });
}

export function ObterDocumento({ vinculo, protocolo }) {
  return buildEncryptedDocumentUrl(baseURL, { vinculo, protocolo });
}

export async function ObterImagem({ vinculo, documento, original }) {
  return await fetchEncryptedImage(baseURL, { vinculo, documento, original });
}

export async function ObterProtocolos({ vinculo, protocolo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterProtocolos`,
      query: {
        vinculo,
        protocolo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterProtocolos", error.message);
      return error;
    });
}

export async function ObterTiposSolicitacao({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterTiposSolicitacao`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterTiposSolicitacao", error.message);
      return error;
    });
}

export async function RetornoPendencia({ vinculo, protocolo, observacao, arquivos }) {
  const data = new FormData();
  data.append("protocolo", protocolo);
  data.append("observacao", observacao);
  appendFiles(data, arquivos);

  return globalThis.window.$axios
    .post({
      url: `${baseURL}/RetornoPendencia`,
      query: {
        vinculo
      },
      contentType: "multipart/form-data",
      data
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("RetornoPendencia", error.message);
      return error;
    });
}
